import { apiFetch } from "./apiClient";

export const authApi = {
  checkPhone: (phone) =>
    apiFetch(`/api/auth/check-phone?phone=${encodeURIComponent(phone)}`, { method: "GET" }),
  register: (payload) => apiFetch("/api/auth/register", { method: "POST", body: payload }),
  login: (payload) => apiFetch("/api/auth/login", { method: "POST", body: payload }),
  loginOtp: (payload) => apiFetch("/api/auth/login-otp", { method: "POST", body: payload }),
  verifyOtp: (payload) => apiFetch("/api/auth/verify-otp", { method: "POST", body: payload }),
  // Impersonation — only mounted in dev; returns 404 in prod. The IT_ADMIN
  // nav item that calls these is hidden in prod via the same gate flag
  // baked into the build.
  impersonateSearch: (q, token) =>
    apiFetch(`/api/auth/impersonate/search?q=${encodeURIComponent(q || "")}`, {
      method: "GET",
      token,
    }),
  impersonate: (targetUserId, token) =>
    apiFetch("/api/auth/impersonate", {
      method: "POST",
      body: { target_user_id: targetUserId },
      token,
    }),
  exitImpersonation: (token) =>
    apiFetch("/api/auth/impersonate/exit", { method: "POST", token }),
  // Re-scope the session to one of the caller's own roles (e.g. an admin
  // switching into their resident view). Returns a fresh token pair carrying
  // the signed `act` scope plus the updated user blob.
  switchRole: (role, token) =>
    apiFetch("/api/auth/switch-role", { method: "POST", body: { role }, token }),
};

export const villaApi = {
  list: (token) => apiFetch("/api/villas", { method: "GET", token }),
  requestAccess: (payload, token) =>
    apiFetch("/api/residents/request-access", { method: "POST", body: payload, token }),
};

export const usersApi = {
  onboard: (payload, token) =>
    apiFetch("/api/users/onboard", { method: "POST", body: payload, token }),
  onboardBulk: (file, token) => {
    const fd = new FormData();
    fd.append("file", file);
    return apiFetch("/api/users/onboard-bulk", {
      method: "POST",
      formData: fd,
      token,
    });
  },
};
